import {
  create_product,
  update_product,
  delete_product,
  recover_product,
  query_product_list,
} from '@/api/jms-model';
import { TableColumn } from '@/typing';
import { SearchConfig, Record } from '@/components/page-model/typing';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
import {
  slotList,
  btn_list,
  head_btn_list,
  event_obj,
  config,
} from '@/components/page-model/jms/jms-product-config';

import { reactive } from 'vue';
import {get_is_active, get_is_active2, toFixed0} from '@/utils/function';

const None = null;
const True = true;
const False = false;

const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org

const search_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'inline',
  },
  fields: [
    {
      type: 'input',
      name: 'code',
      label: '产品编号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写产品编号',
    },
    {
      type: 'input',
      name: 'name',
      label: '产品名称',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写产品名称',
    },
    {
      type: 'input',
      name: 'gg',
      label: '产品规格',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写产品规格',
    },
  ],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    name: null,
    code: null,
    gg: null,
  }),
};
const search_options = {
  is_active: [
    { value: None, name: '全部' },
    { value: True, name: '可用' },
    { value: False, name: '作废' },
  ],
};

const edit_model_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
  },
  fields: [
    {
      type: 'input',
      name: 'name',
      label: '产品名称',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写产品名称',
    },

    {
      type: 'input',
      name: 'gg',
      label: '产品规格',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写产品规格',
    },
    {
      type: 'input',
      name: 'dw',
      label: '产品单位',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写产品单位',
    },
    {
      type: 'input',
      name: 'price',
      label: '产品单价',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写产品单价',
    },
    {
      type: 'remoteselect',
      name: 'product_type_id',
      label: '存货类别',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      datasourceType: 'remote',
      mode: 'default',
      modalType: 'jms-producttype',
      placeholder: '请填写存货类别',
    },
  ],
  rules: {
    name: [{ required: true, message: '请填输入产品名称' }],
    dw: [{ required: true, message: '请填输入产品单位' }],
    price: [{ required: true, message: '请填输入产品价格' }],
    product_type_id: [{ required: true, message: '请填输入存货类别' }],
  },
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    name: null,
    code: null,
    gg: null,
    dw: null,
    price: null,
  }),
};
const edit_model_config_options = {};

const update_model_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
  },
  fields: [
    {
      type: 'input',
      name: 'name',
      label: '产品名称',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写产品名称',
    },
    {
      type: 'input',
      name: 'gg',
      label: '产品规格',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写产品规格',
    },
    {
      type: 'input',
      name: 'dw',
      label: '产品单位',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写产品单位',
    },
    {
      type: 'input',
      name: 'price',
      label: '产品单价',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写产品单价',
    },
    {
      type: 'remoteselect',
      name: 'product_type_id',
      label: '存货类别',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      datasourceType: 'remote',
      mode: 'default',
      modalType: 'jms-producttype',
      placeholder: '请填写存货类别',
    },
  ],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    name: null,
    code: null,
    gg: null,
    dw: null,
    price: null,
  }),
};
const update_model_config_options = {};

const titleList = {
  title: '商品管理',
  addModalTitle: '新建商品',
  updateTitle: '修改商品',
  is_create: true, // 是否有【新建】按钮
  is_update: true, // 是否有【修改】按钮
  is_remove: true, // 是否有【删除】按钮
  is_recover: true, // 是否有【恢复】按钮
};

const api_fields: Record = {
  update: {
    product_id: 'id',
  },
  delete: {
    product_id: 'id',
  },
  recover: {
    product_id: 'id',
  },
  updateData: {
    org_id: 'org_id',
    product_id: 'id',
  },
};

const baseColumns: TableColumn[] = [
  {
    title: '序号',
    dataIndex: 'index',
    width: 50,
  },
  {
    title: '产品编号',
    dataIndex: 'code',
    checked: true,
  },
  {
    title: '产品名称',
    dataIndex: 'name',
    checked: true,
  },
  {
    title: '产品规格',
    dataIndex: 'gg',
    checked: true,
  },
  {
    title: '产品单位',
    dataIndex: 'dw',
    checked: true,
  },
  {
    title: '产品单价',
    dataIndex: 'price',
    checked: true,
    content: (record: any, text: any) => {
      return toFixed0(text);
    },
  },
  {
    title: '操作',
    width: 200,
    dataIndex: 'is_active',
    checked: true,
    cellComponent: 'action',
    fixed: 'right',
    filterMultiple: false,
    filters: [
      { text: '全部', value: '' },
      { text: '可用', value: true },
      { text: '作废', value: false },
    ],
    content: (record: any, text: any) => {
      return get_is_active2(text);
    },
  },
];
const newSlotList: any = [];
Object.assign(newSlotList, slotList);
newSlotList.push({
  type: 'custom',
  // slotName: 'is_active',
  field_true: '可用',
  field_false: '作废',
});

export default () => {
  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: query_product_list,
    addData: create_product,
    updateData: update_product,
    removeData: delete_product,
    recoverData: recover_product,
    baseColumns: baseColumns,
    slotList: newSlotList,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
  };
};
